import {
  CollectionOptions,
  ContentInstructions,
  CoreContents,
  ExportOptions,
  FromSettingsInstruction,
  GenAiOptions,
} from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type MultiKpiOptions = {
  data?: DataOptionsFactory;
  displayAs?: string | FromSettingsInstruction;
  kpis: string[] | FromSettingsInstruction;
  maxKpis?: number;
  xColumn: string | FromSettingsInstruction;
  exportOptions?: ExportOptions;
  collectionOptions?: CollectionOptions;
  genAiOptions?: GenAiOptions;
};

export class MultiKpiFactory extends ContentFactory {
  constructor(options: MultiKpiOptions) {
    const { displayAs, xColumn, data, kpis, maxKpis, exportOptions, collectionOptions, genAiOptions } = options;

    const instructions: ContentInstructions = {
      xColumn:
        typeof xColumn === 'string'
          ? {
              type: 'StringInstruction',
              instruction: xColumn,
            }
          : xColumn,
      kpis: Array.isArray(kpis)
        ? {
            type: 'StringListInstruction',
            instruction: kpis,
          }
        : kpis,
      ...(exportOptions && {
        export: {
          type: 'ObjectInstruction',
          instruction: exportOptions,
        },
      }),
      ...(collectionOptions && {
        collection: {
          type: 'ObjectInstruction',
          instruction: collectionOptions,
        },
      }),
      ...(genAiOptions && {
        genAi: {
          type: 'ObjectInstruction',
          instruction: genAiOptions,
        },
      }),
    };

    if (displayAs) {
      instructions.displayAs =
        typeof displayAs === 'string'
          ? {
              type: 'StringInstruction',
              instruction: displayAs,
            }
          : displayAs;
    }

    if (maxKpis) {
      instructions.maxKpis = {
        type: 'NumberInstruction',
        instruction: maxKpis,
      };
    }

    super(CoreContents.multiKpi, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
